// Ancient Japan Trainers Data - Group Three (Characters 13-18)

// Sohei Warrior Monk's workout programs
const soheiWarriorMonkPrograms = [
    {
        id: 'temple-defender-training',
        name: 'Temple Defender Training',
        description: 'Sacred warrior conditioning for protecting Buddhist temples',
        pattern: '$x&*@d',
        reps: 14,
        sets: 4,
        focus: 'Sacred Defense'
    },
    {
        id: 'naginata-mastery-workout',
        name: 'Naginata Mastery Workout',
        description: 'Long-weapon combat training with spiritual discipline',
        pattern: 'x$*&d@',
        reps: 16,
        sets: 5,
        focus: 'Polearm Mastery'
    },
    {
        id: 'warrior-meditation-conditioning',
        name: 'Warrior Meditation Conditioning',
        description: 'Combat readiness achieved through meditative practice',
        pattern: '&@dx$*',
        reps: 8,
        sets: 7,
        focus: 'Meditative Combat'
    },
    {
        id: 'buddhist-strength-protocol',
        name: 'Buddhist Strength Protocol',
        description: 'Righteous power that protects the innocent and weak',
        pattern: '*d@&x$',
        reps: 18,
        sets: 3,
        focus: 'Righteous Power'
    },
    {
        id: 'monastery-guardian-training',
        name: 'Monastery Guardian Training',
        description: 'Defensive conditioning for mountain temple protection',
        pattern: '@$*dx&',
        reps: 12,
        sets: 6,
        focus: 'Mountain Defense'
    },
    {
        id: 'enlightened-warrior-mastery',
        name: 'Enlightened Warrior Mastery',
        description: 'Perfect fusion of Buddhist wisdom and martial excellence',
        pattern: '$x&*@d!',
        reps: 22,
        sets: 4,
        focus: 'Enlightened Combat'
    }
];

// Date Masamune's workout programs
const dateMasamunePrograms = [
    {
        id: 'one-eyed-dragon-training',
        name: 'One-Eyed Dragon Training',
        description: 'Adapted fighting techniques that turn disability into advantage',
        pattern: 'khmezt',
        reps: 17,
        sets: 3,
        focus: 'Adaptive Excellence'
    },
    {
        id: 'crescent-moon-conditioning',
        name: 'Crescent Moon Conditioning',
        description: 'Distinctive armor training with European-influenced techniques',
        pattern: 'mhketz',
        reps: 21,
        sets: 4,
        focus: 'Cultural Fusion'
    },
    {
        id: 'sendai-domain-workout',
        name: 'Sendai Domain Workout',
        description: 'Regional leadership training for northern Japanese territories',
        pattern: 'eztkhm',
        reps: 15,
        sets: 5,
        focus: 'Regional Command'
    },
    {
        id: 'innovative-warfare-protocol',
        name: 'Innovative Warfare Protocol',
        description: 'Revolutionary combat methods mixing Eastern and Western styles',
        pattern: 'tzmhke',
        reps: 19,
        sets: 3,
        focus: 'Combat Innovation'
    },
    {
        id: 'flamboyant-leader-training',
        name: 'Flamboyant Leader Training',
        description: 'Charismatic leadership through bold and decisive action',
        pattern: 'hketmz',
        reps: 13,
        sets: 6,
        focus: 'Charismatic Leadership'
    },
    {
        id: 'dragon-lord-mastery',
        name: 'Dragon Lord Mastery',
        description: 'Complete training of the most flamboyant and effective daimyo',
        pattern: 'khmezt!',
        reps: 25,
        sets: 3,
        focus: 'Dragon Mastery'
    }
];

// Uesugi Kenshin's workout programs
const uesugiKenshinPrograms = [
    {
        id: 'dragon-of-echigo-training',
        name: 'Dragon of Echigo Training',
        description: 'Undefeated warrior conditioning with spiritual warrior discipline',
        pattern: 'abc+zs',
        reps: 11,
        sets: 8,
        focus: 'Undefeated Spirit'
    },
    {
        id: 'avatar-of-war-conditioning',
        name: 'Avatar of War Conditioning',
        description: 'Divine warrior training channeling the god of war Bishamonten',
        pattern: '+abcsz',
        reps: 28,
        sets: 2,
        focus: 'Divine Warfare'
    },
    {
        id: 'rival-to-takeda-workout',
        name: 'Rival to Takeda Workout',
        description: 'Elite conditioning to match the greatest cavalry commander',
        pattern: 'sza+bc',
        reps: 16,
        sets: 4,
        focus: 'Elite Rivalry'
    },
    {
        id: 'never-defeated-protocol',
        name: 'Never Defeated Protocol',
        description: 'Legendary training methods that ensure victory in every battle',
        pattern: 'c+zsab',
        reps: 23,
        sets: 3,
        focus: 'Eternal Victory'
    },
    {
        id: 'warrior-saint-training',
        name: 'Warrior Saint Training',
        description: 'Perfect balance of Buddhist devotion and martial supremacy',
        pattern: 'bzc+as',
        reps: 7,
        sets: 9,
        focus: 'Saintly Warrior'
    },
    {
        id: 'god-of-war-mastery',
        name: 'God of War Mastery',
        description: 'Ultimate training of the avatar of Bishamonten on earth',
        pattern: 'abc+zs!',
        reps: 30,
        sets: 3,
        focus: 'Divine Mastery'
    }
];

// Emperor Meiji's workout programs
const emperorMeijiPrograms = [
    {
        id: 'restoration-conditioning',
        name: 'Restoration Conditioning',
        description: 'Revolutionary training for modernizing ancient traditions',
        pattern: '>:}={[',
        reps: 14,
        sets: 4,
        focus: 'Modernization Power'
    },
    {
        id: 'imperial-modernization-workout',
        name: 'Imperial Modernization Workout',
        description: 'East-meets-West training combining tradition with innovation',
        pattern: ':}>=[{',
        reps: 18,
        sets: 3,
        focus: 'Cultural Integration'
    },
    {
        id: 'enlightened-emperor-training',
        name: 'Enlightened Emperor Training',
        description: 'Progressive leadership conditioning for transformative rule',
        pattern: '}={[:>',
        reps: 12,
        sets: 6,
        focus: 'Progressive Leadership'
    },
    {
        id: 'charter-oath-protocol',
        name: 'Charter Oath Protocol',
        description: 'Constitutional training based on five fundamental principles',
        pattern: '=[{>:}',
        reps: 5,
        sets: 10,
        focus: 'Constitutional Strength'
    },
    {
        id: 'civilization-builder-conditioning',
        name: 'Civilization Builder Conditioning',
        description: 'Nation-building strength for creating modern Japan',
        pattern: '{[:}>=',
        reps: 22,
        sets: 3,
        focus: 'Nation Building'
    },
    {
        id: 'meiji-transformation-mastery',
        name: 'Meiji Transformation Mastery',
        description: 'Complete training for leading Japan into the modern era',
        pattern: '>:}={[!',
        reps: 20,
        sets: 4,
        focus: 'Transformational Leadership'
    }
];

// Onmyoji Mystic's workout programs
const onmyojiMysticPrograms = [
    {
        id: 'yin-yang-balance-training',
        name: 'Yin Yang Balance Training',
        description: 'Perfect equilibrium of opposing forces within the body',
        pattern: 'fgvpuj',
        reps: 6,
        sets: 6,
        focus: 'Cosmic Balance'
    },
    {
        id: 'court-magician-conditioning',
        name: 'Court Magician Conditioning',
        description: 'Sophisticated training for serving imperial court functions',
        pattern: 'gfpvju',
        reps: 9,
        sets: 5,
        focus: 'Court Sophistication'
    },
    {
        id: 'elemental-mastery-workout',
        name: 'Elemental Mastery Workout',
        description: 'Training that harmonizes with wood, fire, earth, metal, water',
        pattern: 'vupjfg',
        reps: 15,
        sets: 4,
        focus: 'Five Elements'
    },
    {
        id: 'divination-strength-protocol',
        name: 'Divination Strength Protocol',
        description: 'Physical conditioning enhanced by mystical foresight',
        pattern: 'pjugfv',
        reps: 12,
        sets: 7,
        focus: 'Prophetic Power'
    },
    {
        id: 'astronomical-conditioning',
        name: 'Astronomical Conditioning',
        description: 'Training aligned with celestial movements and star patterns',
        pattern: 'jufgvp',
        reps: 24,
        sets: 3,
        focus: 'Celestial Alignment'
    },
    {
        id: 'imperial-mystic-mastery',
        name: 'Imperial Mystic Mastery',
        description: 'Complete training of the emperor\'s most trusted spiritual advisor',
        pattern: 'fgvpuj!',
        reps: 18,
        sets: 4,
        focus: 'Imperial Mysticism'
    }
];

// Noh Master's workout programs
const nohMasterPrograms = [
    {
        id: 'masked-spirit-training',
        name: 'Masked Spirit Training',
        description: 'Supernatural conditioning for channeling ancient spirits',
        pattern: 'wadz_^',
        reps: 10,
        sets: 8,
        focus: 'Spirit Channeling'
    },
    {
        id: 'otherworldly-dance-conditioning',
        name: 'Otherworldly Dance Conditioning',
        description: 'Ethereal movement training that transcends physical limitations',
        pattern: 'azd^w_',
        reps: 13,
        sets: 5,
        focus: 'Ethereal Movement'
    },
    {
        id: 'timeless-performance-workout',
        name: 'Timeless Performance Workout',
        description: 'Endurance training for performances that span hours',
        pattern: 'd_^wza',
        reps: 26,
        sets: 3,
        focus: 'Timeless Endurance'
    },
    {
        id: 'ancient-story-protocol',
        name: 'Ancient Story Protocol',
        description: 'Narrative conditioning that embodies centuries of tales',
        pattern: '^zaw_d',
        reps: 17,
        sets: 4,
        focus: 'Living Stories'
    },
    {
        id: 'supernatural-grace-training',
        name: 'Supernatural Grace Training',
        description: 'Haunting beauty achieved through perfect physical control',
        pattern: '_dwaz^',
        reps: 14,
        sets: 6,
        focus: 'Haunting Grace'
    },
    {
        id: 'eternal-performance-mastery',
        name: 'Eternal Performance Mastery',
        description: 'Complete training for becoming a vessel of ancient wisdom',
        pattern: 'wadz_^!',
        reps: 21,
        sets: 4,
        focus: 'Eternal Artistry'
    }
];

// Main Ancient Japan trainers data object - Group Three
const japanThreeTrainersData = {
    'sohei-warrior-monk': {
        id: 'sohei-warrior-monk',
        name: 'Sohei Warrior Monk',
        specialization: 'Sacred Combat & Temple Defense',
        image: '/assets/images/sohei-monk.jpg',
        experience: '40+ years',
        category: 'ancient-japan',
        color: '#8B4513',
        secondaryColor: '#FF8C00',
        intro: `The Sohei Warrior Monk combines Buddhist devotion with fierce martial prowess, protecting sacred temples from those who would desecrate them. His naginata training builds both spiritual discipline and devastating combat effectiveness. Students learn that righteous anger, properly channeled, becomes a force for protection and justice.`,
        programs: soheiWarriorMonkPrograms
    },
    'date-masamune': {
        id: 'date-masamune',
        name: 'Date Masamune',
        specialization: 'Adaptive Combat & Cultural Innovation',
        image: '/assets/images/date-masamune.jpg',
        experience: '68+ years',
        category: 'ancient-japan',
        color: '#000000',
        secondaryColor: '#C0C0C0',
        intro: `The One-Eyed Dragon who turned physical limitation into tactical advantage, Date Masamune pioneered innovative fighting techniques that mixed Eastern tradition with Western innovation. His flamboyant leadership style teaches that true strength comes from adapting challenges into opportunities for greatness.`,
        programs: dateMasamunePrograms
    },
    'uesugi-kenshin': {
        id: 'uesugi-kenshin',
        name: 'Uesugi Kenshin',
        specialization: 'Divine Warfare & Undefeated Spirit',
        image: '/assets/images/uesugi-kenshin.jpg',
        experience: '48+ years',
        category: 'ancient-japan',
        color: '#4169E1',
        secondaryColor: '#FFFFFF',
        intro: `Known as the Avatar of Bishamonten, the god of war, Uesugi Kenshin never lost a single battle through his perfect fusion of Buddhist spirituality and martial supremacy. His training develops warriors who fight not for conquest, but for justice and divine purpose. True victory comes from spiritual clarity.`,
        programs: uesugiKenshinPrograms
    },
    'emperor-meiji': {
        id: 'emperor-meiji',
        name: 'Emperor Meiji',
        specialization: 'Modernization Leadership & Progressive Training',
        image: '/assets/images/emperor-meiji.jpg',
        experience: '45+ years',
        category: 'ancient-japan',
        color: '#800080',
        secondaryColor: '#FFD700',
        intro: `The emperor who opened Japan to the world while preserving its essential spirit, Emperor Meiji represents the perfect balance of tradition and innovation. His training methods combine ancient Japanese discipline with modern international techniques, creating leaders capable of transforming entire civilizations.`,
        programs: emperorMeijiPrograms
    },
    'onmyoji-mystic': {
        id: 'onmyoji-mystic',
        name: 'Onmyoji Mystic',
        specialization: 'Elemental Balance & Court Mysticism',
        image: '/assets/images/onmyoji-mystic.jpg',
        experience: '35+ years',
        category: 'ancient-japan',
        color: '#4B0082',
        secondaryColor: '#DAA520',
        intro: `Master of the five elements and yin-yang philosophy, the Onmyoji Mystic serves as spiritual advisor to emperors and nobles. His training harmonizes body with cosmic forces, teaching students to find perfect balance between opposing energies. True power flows from understanding natural law and celestial rhythm.`,
        programs: onmyojiMysticPrograms
    },
    'noh-master': {
        id: 'noh-master',
        name: 'Noh Master',
        specialization: 'Supernatural Performance & Timeless Artistry',
        image: '/assets/images/noh-master.jpg',
        experience: '50+ years',
        category: 'ancient-japan',
        color: '#8B0000',
        secondaryColor: '#F5F5DC',
        intro: `Through masked performance that channels ancient spirits, the Noh Master achieves supernatural grace and otherworldly endurance. His training transforms students into vessels for timeless stories, developing the physical control needed to embody centuries of cultural wisdom in living performance art.`,
        programs: nohMasterPrograms
    }
};

// Export the data
export default japanThreeTrainersData;